export const endPoint = "https://qbmedia.b-cdn.net/luqmaimages"
// https://qbmedia.b-cdn.net/luqmaimages
export const url = "https://menu.luqma.co.il/"

export const bizNUM = '972522350099'
export const bizNUM2 = '046034444'
export const bizFB = 'luqma'
export const bizIG = 'luqma.co.il'
export const bizWEB = 'luqma.co.il'
